import React, { useEffect } from 'react'

import { useFeature } from '@acorns/web-toggles-react'

import { oakRedirectOAuth } from 'utils/experiments/features'

import Login from '../login'

function OAuthLogin() {
  const [oakRedirectOAuthIsEnabled] = useFeature(oakRedirectOAuth)

  useEffect(
    function handleRedirectToOakOAuthSignIn() {
      if (oakRedirectOAuthIsEnabled) {
        window.location.href =
          process.env.OAK_OAUTH_SIGN_IN_URL + location.search
      }
    },
    [oakRedirectOAuthIsEnabled],
  )

  if (oakRedirectOAuthIsEnabled) {
    return null
  }

  return <Login isOAuth={true} />
}

export default OAuthLogin
